import { Icon } from '@pixum/icon';
import Text, { TEXT_VARIANT } from '@pixum/text';
import { TextInput } from '@pixum/web-input';
import Button, { ButtonSizes, ButtonVariants } from '@pixum/button';
import styles from './CartVoucher.module.css';
import type { ChangeEvent } from 'react';

const ACCORDION_STATE_OPEN = 'open';
const ACCORDION_STATE_CLOSED = 'closed';

interface DefaultVoucherProps {
  inputValue: string;
  isOpen: boolean;
  isApplying: boolean;
  hasError: boolean;
  errorMessage: string;
  onAccordionClick: () => void;
  onInputChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onFocus: () => void;
  applyFormAction: (formData: FormData) => void;
  constants: {
    headlineText: string;
    inputLabel: string;
    submitButtonText: string;
  };
}

export function DefaultVoucher({
  inputValue,
  isOpen,
  isApplying,
  hasError,
  errorMessage,
  onAccordionClick,
  onInputChange,
  onFocus,
  applyFormAction,
  constants,
}: DefaultVoucherProps) {
  return (
    <div className={styles.container}>
      <button
        type="button"
        onClick={onAccordionClick}
        className={styles.accordionButton}
        aria-expanded={isOpen}
        aria-controls="voucher-form"
      >
        <Text variant={TEXT_VARIANT.HEADLINE}>{constants.headlineText}</Text>
        <Icon name="chevron-right" />
      </button>

      <div className={styles.formWrapper} data-state={isOpen ? ACCORDION_STATE_OPEN : ACCORDION_STATE_CLOSED}>
        <form id="voucher-form" action={applyFormAction} className={styles.form}>
          <div className={styles.voucherInputWrapper}>
            <TextInput
              label={constants.inputLabel}
              name="code"
              value={inputValue}
              onChange={onInputChange}
              onFocus={onFocus}
              disabled={isApplying}
              required
              hasError={hasError}
              inputInfo={errorMessage}
            />
          </div>

          <Button
            disabled={!inputValue.trim() || isApplying}
            className={styles.submitButton}
            isBusy={isApplying}
            size={ButtonSizes.MEDIUM}
            variant={ButtonVariants.SECONDARY}
          >
            {constants.submitButtonText}
          </Button>
        </form>
      </div>
    </div>
  );
}
